module.exports = __webpack_public_path__ + "img/envelope.4a546445.svg";